<template>
  <div class="form-item-flexbox">
    <form-item v-for="child in element.elements" :key="child.key" :element="child" />
  </div>
</template>
<script setup lang="ts">
import { type WebformElementWebformFlexboxFragment, type WebformSubmissionValidationErrorFragment } from '#graphql-operations'

defineProps<{
  element: WebformElementWebformFlexboxFragment
  formErrors: WebformSubmissionValidationErrorFragment[]
}>()
</script>

<style lang="scss" scoped>
@use "~/assets/sass/tools";

.form-item-flexbox {
  display: flex;
  gap: var(--space--sm);
  @include tools.to(tools.$breakpoint--desktop) {
    flex-direction: column;
    gap: 0;
  }

  .form-item {
    flex-grow: 1;

    &:first-child {
      margin-top: 0;
    }

    &:nth-child(2) {
      @include tools.from(tools.$breakpoint--desktop) {
        margin-top: 0;
      }
    }
  }
}
</style>
